import _ from 'underscore';
import lobIconUtil from 'integration/platform/lobUtil/lobIconUtil';

function _initializeCustomFilters(scope) {
    // ** START CUSTOM FILTERS **
    scope.policyLinesFilter = {
        displayKey: 'gateway.views.policy-landing.Policy Line',
        displayValue: '',
        options: []
    };

    // ** POLICY FILTER
    scope.billingStatusFilter = {
        displayKey: 'gateway.views.policy-landing.Billing Status',
        displayValue: '',
        options: [{
            code: 'inGoodStanding',
            displayKey: 'gateway.views.policy-landing.In Good Standing',
            displayValue: '',
            selected: false
        }, {
            code: 'delinquent',
            displayKey: 'gateway.views.policy-landing.Delinquent',
            displayValue: '',
            selected: false
        }]
    };

    scope.policyStatusFilter = {
        displayKey: 'gateway.views.policy-landing.Status',
        displayValue: '',
        options: []
    };

    scope.policyFilter = {
        displayKey: 'gateway.views.policy-landing.Policies',
        displayValue: '',
        filters: [scope.billingStatusFilter, scope.policyStatusFilter]
    };

    // ** QUOTE / SUBMISSION FILTER
    scope.quoteStatusFilter = {
        displayKey: 'gateway.views.policy-landing.Status',
        displayValue: '',
        options: []
    };

    scope.quoteFilter = {
        displayKey: 'gateway.views.policy-landing.Quotes',
        displayValue: '',
        filters: [scope.quoteStatusFilter]
    };

    // ** RENEWAL FILTER
    scope.renewalStatusFilter = {
        displayKey: 'gateway.views.policy-landing.Status',
        displayValue: '',
        options: []
    };

    scope.renewalFilter = {
        displayKey: 'gateway.views.policy-landing.Renewal',
        displayValue: '',
        filters: [scope.renewalStatusFilter]
    };

    // ** POLICYCHANGE FILTER
    scope.policyChangeStatusFilter = {
        displayKey: 'gateway.views.policy-landing.Status',
        displayValue: '',
        options: []
    };

    scope.policyChangeFilter = {
        displayKey: 'gateway.views.policy-landing.Change',
        displayValue: '',
        filters: [scope.policyChangeStatusFilter]
    };

    // ** CANCELLATION FILTER
    scope.cancellationStatusFilter = {
        displayKey: 'gateway.views.policy-landing.Status',
        displayValue: '',
        options: []
    };

    scope.cancellationFilter = {
        displayKey: 'gateway.views.policy-landing.Cancellation',
        displayValue: '',
        filters: [scope.cancellationStatusFilter]
    };

    scope.customFilter = {
        lobFilter: scope.policyLinesFilter,
        filter: scope.policyFilter
    };
    // ** END CUSTOM FILTERS **
}

function _initializeQuickFilters(scope) {
    // ** START QUICK FILTERS **
    scope.recentlyViewedFilter = {
        name: 'recentlyViewed',
        displayValue: '',
        displayKey: 'gateway.views.policy-landing.Recently Viewed'
    };
    scope.recentlyIssuedFilter = {
        name: 'recentlyIssued',
        displayValue: '',
        displayKey: 'gateway.views.policy-landing.Recently Issued'
    };
    scope.delinquentPoliciesFilter = {
        name: 'delinquentPolicies',
        displayValue: '',
        displayKey: 'gateway.views.policy-landing.Delinquent'
    };
    scope.openQuotesFilter = {
        name: 'openQuotes',
        displayValue: '',
        displayKey: 'gateway.views.policy-landing.Open Quotes'
    };
    scope.openRenewalsFilter = {
        name: 'openRenewals',
        displayValue: '',
        displayKey: 'gateway.views.policy-landing.Open Renewals'
    };
    scope.openPolicyChangesFilter = {
        name: 'openPolicyChanges',
        displayValue: '',
        displayKey: 'gateway.views.policy-landing.Open Changes'
    };
    scope.openCancellationsFilter = {
        name: 'openCancellations',
        displayValue: '',
        displayKey: 'gateway.views.policy-landing.Open Cancellations'
    };
    // ** END QUICK FILTERS **
}

function _translateFilters(scope, translateFunction) {
    scope.translationObjects = [scope.recentlyViewedFilter, scope.recentlyIssuedFilter, scope.delinquentPoliciesFilter, scope.openQuotesFilter, scope.openRenewalsFilter, scope.openPolicyChangesFilter, scope.openCancellationsFilter, scope.policyLinesFilter, scope.billingStatusFilter, scope.policyStatusFilter, scope.policyFilter, scope.quoteStatusFilter, scope.quoteFilter, scope.renewalStatusFilter, scope.renewalFilter, scope.policyChangeStatusFilter, scope.policyChangeFilter, scope.cancellationStatusFilter, scope.cancellationFilter, scope.billingStatusFilter.options[0], scope.billingStatusFilter.options[1]];

    translateFunction(scope.translationObjects);
}

/**
 * Set the status of the active quick filters
 * @param {Object} scope
 */
function _setActiveQuickFilter(scope) {
    scope.recentlyViewedFilterActive = scope.currentQuickFilter === scope.recentlyViewedFilter;
    scope.recentlyIssuedFilterActive = scope.currentQuickFilter === scope.recentlyIssuedFilter;
    scope.delinquentPoliciesFilterActive = scope.currentQuickFilter === scope.delinquentPoliciesFilter;
    scope.openQuotesFilterActive = scope.currentQuickFilter === scope.openQuotesFilter;
    scope.openRenewalsFilterActive = scope.currentQuickFilter === scope.openRenewalsFilter;
    scope.openPolicyChangesFilterActive = scope.currentQuickFilter === scope.openPolicyChangesFilter;
    scope.openCancellationsFilterActive = scope.currentQuickFilter === scope.openCancellationsFilter;
}

/**
 * Set the number of open jobs for each job type in the given list
 * @param {Object} scope
 * @param {Object} jobs
 */
function _setNumberOfOpenJobs(scope, jobs) {
    scope.numberOfOpenQuotes = 0;
    scope.numberOfOpenRenewals = 0;
    scope.numberOfOpenPolicyChanges = 0;
    //scope.numberOfOpenCancellations = 0;

    if (angular.isDefined(jobs) && jobs.length > 0) {
        scope.numberOfOpenQuotes = _.where(jobs, {
            type: 'Submission'
        }).length;
        scope.numberOfOpenRenewals = _.where(jobs, {
            type: 'Renewal'
        }).length;
        scope.numberOfOpenPolicyChanges = _.where(jobs, {
            type: 'PolicyChange'
        }).length;
        /*scope.numberOfOpenCancellations = _.where(jobs, {
            type: 'Cancellation'
        }).length; */
    }
}

/**
 * Set the custom filter sub options to true for the current quick filter
 * @param {Object} scope
 * @param {Object} customFilter
 * @param {*} filter
 */
function _setCustomFilterFieldsForQuickFilter(scope, customFilter, filter) {
    if (angular.isDefined(filter) && filter !== null) {
        if (angular.isDefined(customFilter.filter.filters)) {
            if (filter === scope.delinquentPoliciesFilter) {
                customFilter.filter.filters.forEach(function (subFilter) {
                    if (subFilter === scope.billingStatusFilter) {
                        subFilter.options.forEach(function (option) {
                            option.selected = option.code === 'delinquent';
                        });
                    } else {
                        subFilter.options.forEach(function (option) {
                            option.selected = true;
                        });
                    }
                });
            } else {
                customFilter.filter.filters.forEach(function (subFilter) {
                    subFilter.options.forEach(function (option) {
                        option.selected = true;
                    });
                });
            }
        }
    }
}

/**
 * Set the initial quick filter selection based on the passed parameters
 * @param {Object} scope
 * @param {String} quickFilter
 */
function _setInitialQuickFilter(scope, quickFilter) {
    switch (quickFilter) {
        case 'renewals':
            scope.currentQuickFilter = scope.openRenewalsFilter;
            scope.customFilter.filter = scope.renewalFilter;
            break;
        case 'quotes':
            scope.currentQuickFilter = scope.openQuotesFilter;
            scope.customFilter.filter = scope.quoteFilter;
            break;
        case 'changes':
            scope.currentQuickFilter = scope.openPolicyChangesFilter;
            scope.customFilter.filter = scope.policyChangeFilter;
            break;
        case 'cancellations':
            scope.currentQuickFilter = scope.openCancellationsFilter;
            scope.customFilter.filter = scope.cancellationFilter;
            break;
        default:
            scope.currentQuickFilter = scope.recentlyViewedFilter;
            scope.customFilter.filter = scope.policyFilter;
    }
}

function _checkFilterHasOptionsSelected(filter) {
    var selected = false;
    if (angular.isDefined(filter.options)) {
        for (var i = 0; i < filter.options.length; i++) {
            if (filter.options[i].selected) {
                selected = true;
                break;
            }
        }
    } else {
        return true;
    }

    return selected;
}

/** Get a policy type icon by a policy type.
 * @param {String} policyType policy type code.
 * @returns {String} policy type icon name.
 */
function getPolicyTypeIconName(policyType) {
    return lobIconUtil.getImageIcon(policyType);
}

/**
 * Get a policy icon or a policy type.
 * @param {String} policyType policy type.
 * @returns {String} policy type icon path.
 */
function _getPolicyTypeIcon(policyType) {
    return '../styles/images/common/lob-icons/' + getPolicyTypeIconName(policyType) + '.png';
}

export default {
    'initializeCustomFilters': function initializeCustomFilters(scope) {
        return _initializeCustomFilters(scope);
    },

    'initializeQuickFilters': function initializeQuickFilters(scope) {
        return _initializeQuickFilters(scope);
    },

    'translateFilters': function translateFilters(scope, translateFunction) {
        return _translateFilters(scope, translateFunction);
    },
    'setActiveQuickFilter': function setActiveQuickFilter(scope) {
        return _setActiveQuickFilter(scope);
    },

    'setNumberOfOpenJobs': function setNumberOfOpenJobs(scope, jobs) {
        return _setNumberOfOpenJobs(scope, jobs);
    },

    'setCustomFilterFieldsForQuickFilter': function setCustomFilterFieldsForQuickFilter(scope, customFilter, filter) {
        return _setCustomFilterFieldsForQuickFilter(scope, customFilter, filter);
    },

    'getPolicyTypeIcon': function getPolicyTypeIcon(policyType) {
        return _getPolicyTypeIcon(policyType);
    },

    'setInitialQuickFilter': function setInitialQuickFilter(scope, quickFilter) {
        return _setInitialQuickFilter(scope, quickFilter);
    },

    'checkFilterHasOptionsSelected': function checkFilterHasOptionsSelected(filter) {
        return _checkFilterHasOptionsSelected(filter);
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/util/policylanding/PolicyLandingUtil.js
// module id = 152
// module chunks = 0